/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.2.12
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("whatInput", [], factory);
	else if(typeof exports === 'object')
		exports["whatInput"] = factory();
	else
		root["whatInput"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	  /*
	   * bail out if there is no document or window
	   * (i.e. in a node/non-DOM environment)
	   *
	   * Return a stubbed API instead
	   */
	  if (typeof document === 'undefined' || typeof window === 'undefined') {
	    return {
	      // always return "initial" because no interaction will ever be detected
	      ask: function ask() {
	        return 'initial';
	      },

	      // always return null
	      element: function element() {
	        return null;
	      },

	      // no-op
	      ignoreKeys: function ignoreKeys() {},

	      // no-op
	      specificKeys: function specificKeys() {},

	      // no-op
	      registerOnChange: function registerOnChange() {},

	      // no-op
	      unRegisterOnChange: function unRegisterOnChange() {}
	    };
	  }

	  /*
	   * variables
	   */

	  // cache document.documentElement
	  var docElem = document.documentElement;

	  // currently focused dom element
	  var currentElement = null;

	  // last used input type
	  var currentInput = 'initial';

	  // last used input intent
	  var currentIntent = currentInput;

	  // UNIX timestamp of current event
	  var currentTimestamp = Date.now();

	  // check for a `data-whatpersist` attribute on either the `html` or `body` elements, defaults to `true`
	  var shouldPersist = false;

	  // form input types
	  var formInputs = ['button', 'input', 'select', 'textarea'];

	  // empty array for holding callback functions
	  var functionList = [];

	  // list of modifier keys commonly used with the mouse and
	  // can be safely ignored to prevent false keyboard detection
	  var ignoreMap = [16, // shift
	  17, // control
	  18, // alt
	  91, // Windows key / left Apple cmd
	  93 // Windows menu / right Apple cmd
	  ];

	  var specificMap = [];

	  // mapping of events to input types
	  var inputMap = {
	    keydown: 'keyboard',
	    keyup: 'keyboard',
	    mousedown: 'mouse',
	    mousemove: 'mouse',
	    MSPointerDown: 'pointer',
	    MSPointerMove: 'pointer',
	    pointerdown: 'pointer',
	    pointermove: 'pointer',
	    touchstart: 'touch',
	    touchend: 'touch'

	    // boolean: true if the page is being scrolled
	  };var isScrolling = false;

	  // store current mouse position
	  var mousePos = {
	    x: null,
	    y: null

	    // map of IE 10 pointer events
	  };var pointerMap = {
	    2: 'touch',
	    3: 'touch', // treat pen like touch
	    4: 'mouse'

	    // check support for passive event listeners
	  };var supportsPassive = false;

	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });

	    window.addEventListener('test', null, opts);
	  } catch (e) {}
	  // fail silently


	  /*
	   * set up
	   */

	  var setUp = function setUp() {
	    // add correct mouse wheel event mapping to `inputMap`
	    inputMap[detectWheel()] = 'mouse';

	    addListeners();
	  };

	  /*
	   * events
	   */

	  var addListeners = function addListeners() {
	    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
	    // can only demonstrate potential, but not actual, interaction
	    // and are treated separately
	    var options = supportsPassive ? { passive: true, capture: true } : true;

	    document.addEventListener('DOMContentLoaded', setPersist, true);

	    // pointer events (mouse, pen, touch)
	    if (window.PointerEvent) {
	      window.addEventListener('pointerdown', setInput, true);
	      window.addEventListener('pointermove', setIntent, true);
	    } else if (window.MSPointerEvent) {
	      window.addEventListener('MSPointerDown', setInput, true);
	      window.addEventListener('MSPointerMove', setIntent, true);
	    } else {
	      // mouse events
	      window.addEventListener('mousedown', setInput, true);
	      window.addEventListener('mousemove', setIntent, true);

	      // touch events
	      if ('ontouchstart' in window) {
	        window.addEventListener('touchstart', setInput, options);
	        window.addEventListener('touchend', setInput, true);
	      }
	    }

	    // mouse wheel
	    window.addEventListener(detectWheel(), setIntent, options);

	    // keyboard events
	    window.addEventListener('keydown', setInput, true);
	    window.addEventListener('keyup', setInput, true);

	    // focus events
	    window.addEventListener('focusin', setElement, true);
	    window.addEventListener('focusout', clearElement, true);
	  };

	  // checks if input persistence should happen and
	  // get saved state from session storage if true (defaults to `false`)
	  var setPersist = function setPersist() {
	    shouldPersist = !(docElem.getAttribute('data-whatpersist') === 'false' || document.body.getAttribute('data-whatpersist') === 'false');

	    if (shouldPersist) {
	      // check for session variables and use if available
	      try {
	        if (window.sessionStorage.getItem('what-input')) {
	          currentInput = window.sessionStorage.getItem('what-input');
	        }

	        if (window.sessionStorage.getItem('what-intent')) {
	          currentIntent = window.sessionStorage.getItem('what-intent');
	        }
	      } catch (e) {
	        // fail silently
	      }
	    }

	    // always run these so at least `initial` state is set
	    doUpdate('input');
	    doUpdate('intent');
	  };

	  // checks conditions before updating new input
	  var setInput = function setInput(event) {
	    var eventKey = event.which;
	    var value = inputMap[event.type];

	    if (value === 'pointer') {
	      value = pointerType(event);
	    }

	    var ignoreMatch = !specificMap.length && ignoreMap.indexOf(eventKey) === -1;

	    var specificMatch = specificMap.length && specificMap.indexOf(eventKey) !== -1;

	    var shouldUpdate = value === 'keyboard' && eventKey && (ignoreMatch || specificMatch) || value === 'mouse' || value === 'touch';

	    // prevent touch detection from being overridden by event execution order
	    if (validateTouch(value)) {
	      shouldUpdate = false;
	    }

	    if (shouldUpdate && currentInput !== value) {
	      currentInput = value;

	      persistInput('input', currentInput);
	      doUpdate('input');
	    }

	    if (shouldUpdate && currentIntent !== value) {
	      // preserve intent for keyboard interaction with form fields
	      var activeElem = document.activeElement;
	      var notFormInput = activeElem && activeElem.nodeName && (formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1 || activeElem.nodeName.toLowerCase() === 'button' && !checkClosest(activeElem, 'form'));

	      if (notFormInput) {
	        currentIntent = value;

	        persistInput('intent', currentIntent);
	        doUpdate('intent');
	      }
	    }
	  };

	  // updates the doc and `inputTypes` array with new input
	  var doUpdate = function doUpdate(which) {
	    docElem.setAttribute('data-what' + which, which === 'input' ? currentInput : currentIntent);

	    fireFunctions(which);
	  };

	  // updates input intent for `mousemove` and `pointermove`
	  var setIntent = function setIntent(event) {
	    var value = inputMap[event.type];

	    if (value === 'pointer') {
	      value = pointerType(event);
	    }

	    // test to see if `mousemove` happened relative to the screen to detect scrolling versus mousemove
	    detectScrolling(event);

	    // only execute if scrolling isn't happening
	    if ((!isScrolling && !validateTouch(value) || isScrolling && event.type === 'wheel' || event.type === 'mousewheel' || event.type === 'DOMMouseScroll') && currentIntent !== value) {
	      currentIntent = value;

	      persistInput('intent', currentIntent);
	      doUpdate('intent');
	    }
	  };

	  var setElement = function setElement(event) {
	    if (!event.target.nodeName) {
	      // If nodeName is undefined, clear the element
	      // This can happen if click inside an <svg> element.
	      clearElement();
	      return;
	    }

	    currentElement = event.target.nodeName.toLowerCase();
	    docElem.setAttribute('data-whatelement', currentElement);

	    if (event.target.classList && event.target.classList.length) {
	      docElem.setAttribute('data-whatclasses', event.target.classList.toString().replace(' ', ','));
	    }
	  };

	  var clearElement = function clearElement() {
	    currentElement = null;

	    docElem.removeAttribute('data-whatelement');
	    docElem.removeAttribute('data-whatclasses');
	  };

	  var persistInput = function persistInput(which, value) {
	    if (shouldPersist) {
	      try {
	        window.sessionStorage.setItem('what-' + which, value);
	      } catch (e) {
	        // fail silently
	      }
	    }
	  };

	  /*
	   * utilities
	   */

	  var pointerType = function pointerType(event) {
	    if (typeof event.pointerType === 'number') {
	      return pointerMap[event.pointerType];
	    } else {
	      // treat pen like touch
	      return event.pointerType === 'pen' ? 'touch' : event.pointerType;
	    }
	  };

	  // prevent touch detection from being overridden by event execution order
	  var validateTouch = function validateTouch(value) {
	    var timestamp = Date.now();

	    var touchIsValid = value === 'mouse' && currentInput === 'touch' && timestamp - currentTimestamp < 200;

	    currentTimestamp = timestamp;

	    return touchIsValid;
	  };

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/API/Element/wheel_event
	  var detectWheel = function detectWheel() {
	    var wheelType = null;

	    // Modern browsers support "wheel"
	    if ('onwheel' in document.createElement('div')) {
	      wheelType = 'wheel';
	    } else {
	      // Webkit and IE support at least "mousewheel"
	      // or assume that remaining browsers are older Firefox
	      wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
	    }

	    return wheelType;
	  };

	  // runs callback functions
	  var fireFunctions = function fireFunctions(type) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].type === type) {
	        functionList[i].fn.call(undefined, type === 'input' ? currentInput : currentIntent);
	      }
	    }
	  };

	  // finds matching element in an object
	  var objPos = function objPos(match) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].fn === match) {
	        return i;
	      }
	    }
	  };

	  var detectScrolling = function detectScrolling(event) {
	    if (mousePos.x !== event.screenX || mousePos.y !== event.screenY) {
	      isScrolling = false;

	      mousePos.x = event.screenX;
	      mousePos.y = event.screenY;
	    } else {
	      isScrolling = true;
	    }
	  };

	  // manual version of `closest()`
	  var checkClosest = function checkClosest(elem, tag) {
	    var ElementPrototype = window.Element.prototype;

	    if (!ElementPrototype.matches) {
	      ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.webkitMatchesSelector;
	    }

	    if (!ElementPrototype.closest) {
	      do {
	        if (elem.matches(tag)) {
	          return elem;
	        }

	        elem = elem.parentElement || elem.parentNode;
	      } while (elem !== null && elem.nodeType === 1);

	      return null;
	    } else {
	      return elem.closest(tag);
	    }
	  };

	  /*
	   * init
	   */

	  // don't start script unless browser cuts the mustard
	  // (also passes if polyfills are used)
	  if ('addEventListener' in window && Array.prototype.indexOf) {
	    setUp();
	  }

	  /*
	   * api
	   */

	  return {
	    // returns string: the current input type
	    // opt: 'intent'|'input'
	    // 'input' (default): returns the same value as the `data-whatinput` attribute
	    // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
	    ask: function ask(opt) {
	      return opt === 'intent' ? currentIntent : currentInput;
	    },

	    // returns string: the currently focused element or null
	    element: function element() {
	      return currentElement;
	    },

	    // overwrites ignored keys with provided array
	    ignoreKeys: function ignoreKeys(arr) {
	      ignoreMap = arr;
	    },

	    // overwrites specific char keys to update on
	    specificKeys: function specificKeys(arr) {
	      specificMap = arr;
	    },

	    // attach functions to input and intent "events"
	    // funct: function to fire on change
	    // eventType: 'input'|'intent'
	    registerOnChange: function registerOnChange(fn, eventType) {
	      functionList.push({
	        fn: fn,
	        type: eventType || 'input'
	      });
	    },

	    unRegisterOnChange: function unRegisterOnChange(fn) {
	      var position = objPos(fn);

	      if (position || position === 0) {
	        functionList.splice(position, 1);
	      }
	    },

	    clearStorage: function clearStorage() {
	      window.sessionStorage.clear();
	    }
	  };
	}();

/***/ })
/******/ ])
});
;
"use strict";
"use strict";jQuery(document).foundation();
"use strict";var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();(function(jQuery){// Polyfill for Symbol if needed
if(typeof Symbol==='undefined'){window.Symbol=function _Symbol(key){return key;};}// Cache window and document objects
var $window=jQuery(window);var $document=jQuery(document);// Declare currentPosition and currentTransition globally for use in off-canvas functionality
var currentPosition="";var currentTransition="";// Document ready handler
$document.ready(function(){initJsGlobal();initNavigation();initGalleries();initReplaceFancybox();clickToExpand();// Initialize OffCanvasSwitcher only if the element exists
if(jQuery('#off-canvas').length){initOffCanvasSwitcher();}passFormTitleAsFormName();primaryLinkIconInjection();secondaryLinkIconInjection();dynamicFooterHeight();addActiveClassToMegaMenuItem();pulseButton();aboveFoldSlider();initHellobar();activeTiles();});jQuery(document).ready(function(){jQuery(".wp-block-search__input").each(function(){var searchInput=jQuery(this);var clearButton=jQuery("<span class='custom-search-clear'>&times;</span>");// Wrap input and append clear button
searchInput.wrap("<div style='position: relative; display: inline-block; width: 100%;'></div>");searchInput.after(clearButton);// Show/hide clear button based on input value
function toggleClearButton(){if(searchInput.val().length>0){clearButton.addClass("visible");}else{clearButton.removeClass("visible");}}// Click event to clear input
clearButton.on("click",function(){searchInput.val("").focus();toggleClearButton();});// Input event to show/hide button
searchInput.on("input",toggleClearButton);// Initialize visibility
toggleClearButton();});});jQuery(document).ready(function(){if(window.location.pathname.includes("/contact/")){jQuery("#content").addClass("contact-page");}if(window.location.pathname.includes("/thank-you/")){jQuery("#content").addClass("thank-you-page");}});//Above Fold Swiper Script
//---------------------------------------------------------------
function aboveFoldSlider(){var sliderContainer=jQuery('<div>',{class:'swiper-container above-fold-slider'});var sliderWrapper=jQuery('<div>',{class:'swiper-wrapper'});// Clone the existing figures and append them to the slid er wrapper
jQuery('#logo-section .kt-inside-inner-col figure').each(function(){var slide=jQuery('<div>',{class:'swiper-slide'});var clonedFigure=jQuery(this).clone();slide.append(clonedFigure);sliderWrapper.append(slide);});sliderContainer.append(sliderWrapper);// Append the slider container after the original container
jQuery('#logo-section').append(sliderContainer);// Initialize Swiper
var swiper=new Swiper('.above-fold-slider',{// slidesPerView: 'auto',
centeredSlides:true,spaceBetween:5,initialSlide:1,loop:true,navigation:{// nextEl: '.swiper-button-next',
// prevEl: '.swiper-button-prev',
},breakpoints:{320:{// slidesPerView: 1.3,
// spaceBetween: 20
slidesPerView:2.6,spaceBetween:50},480:{slidesPerView:2.6,spaceBetween:30},540:{slidesPerView:2.6,spaceBetween:30}},autoplay:{delay:3000,// Set the desired autoplay delay in milliseconds
disableOnInteraction:false// Allow autoplay to continue after user interactions
}});}//---------------------------------------------------------------
function initHellobar(){var helloBarContainer=jQuery('#hello-bar-main');if(helloBarContainer.length){jQuery('#hello-bar-close-btn').click(function(){helloBarContainer.animate({maxHeight:'0',opacity:'0',padding:'0'});});}}function pulseButton(){jQuery('.is-style-link-with-play-icon-before >*').each(function(){jQuery(this).prepend('<div class="pulse-button"><svg xmlns="http://www.w3.org/2000/svg" width="13.947" height="16.409" viewBox="0 0 13.947 16.409"><path d="M8.2,0l8.2,13.947H0Z" transform="translate(13.947) rotate(90)" fill="#fff7e8"/></svg></span>');});}function addActiveClassToMegaMenuItem(){// Remove trailing slashes so "/about" and "/about/" are treated the same
function normalizePath(path){return path.replace(/\/+$/,'');}var currentPath=normalizePath(window.location.pathname);// console.log("Current Path:", currentPath);
jQuery('.mega-menu-link-group p a').each(function(){var linkPath=normalizePath(new URL(this.href,window.location.origin).pathname);// console.log("Link Path:", linkPath, "for", this.href);
if(linkPath===currentPath){jQuery(this).addClass('active');// console.log("Active class added to:", this.href);
}});}function activeTiles(){var currentPath=window.location.pathname.replace(/\/$/,'');// Get current path and normalize by removing trailing slash
console.log('Current page pathname:',currentPath);// Loop through <a> tags inside .tile-2 and .tile-3
jQuery('.tile-2 a, .tile-3 a').each(function(){var anchorHref=jQuery(this).attr('href');// Get href attribute of the <a> tag
// console.log('Anchor HREF:', anchorHref);
if(anchorHref){var normalizedHref=anchorHref.replace(/\/$/,'');// Normalize by removing trailing slash
// console.log('Normalized HREF:', normalizedHref);
// Compare current path with normalized href
if(currentPath===normalizedHref){jQuery(this).addClass('active');// Add 'active' class if paths match
// console.log('Match found! Active class added to:', normalizedHref);
}}else{// console.log('No HREF found for this anchor.');
}});}// Inject Arrow Icon into Primary Link W Arrow
function primaryLinkIconInjection(){// Select all instances of .is-style-primary-link-w-arrow
jQuery('.is-style-primary-link-w-arrow a').each(function(){// Append an element with the class .primary-link-icon inside each instance
jQuery(this).wrapInner('<span class="primary-link"></span>');jQuery(this).append('<span class="link-icon"></span>');});}function secondaryLinkIconInjection(){// Select all instances of .is-style-primary-link-w-arrow
jQuery('.is-style-secondary-link-w-arrow a').each(function(){// Append an element with the class .primary-link-icon inside each instance
jQuery(this).wrapInner('<span class="secondary-link"></span>');jQuery(this).append('<span class="link-icon"></span>');});}function dynamicFooterHeight(){var main=jQuery("#visit-office-wrap");var footer=jQuery("#bottom-hidden-footer");// Set initial visibility to hidden
footer.css("visibility","hidden");if(footer.length===0||main.length===0){console.error("Element(s) not found:",{footerExists:footer.length>0,mainExists:main.length>0});return;}var updateDynamicValues=function updateDynamicValues(){var footerHeight=footer.outerHeight()||0;main.css("margin-bottom",footerHeight+"px");};var handleScroll=function handleScroll(){var scrollPosition=window.scrollY+window.innerHeight;var mainBottom=main.offset().top+main.outerHeight();if(scrollPosition>=mainBottom&&main.outerHeight()>0){footer.css("visibility","visible");footer.css("opacity","1");}else{footer.css("visibility","hidden");footer.css("opacity","0");}};// Update values on load
updateDynamicValues();// Listen to resize events
jQuery(window).on("resize",function(){updateDynamicValues();});jQuery(window).on("orientationchange",function(){updateDynamicValues();});// Listen to scroll events
jQuery(window).on("scroll",function(){handleScroll();});// Monitor footer for height changes
var observer=new MutationObserver(function(){updateDynamicValues();});observer.observe(footer[0],{attributes:true,childList:true,subtree:true});// Clean up observer when the page is unloaded
jQuery(window).on("unload",function(){observer.disconnect();});}// Function to optimize form field names for GA4 form tracking
function passFormTitleAsFormName(){jQuery('.gform_wrapper form').each(function(){var $form=jQuery(this);var formTitle=$form.closest('.gform_heading').find('.gform_title').text();var formID=$form.attr('id');$form.attr('name',formTitle+' - '+formID);});}// Remove empty P tags created by WP and add responsive embeds to YouTube and Vimeo
function initJsGlobal(){jQuery('.accordion p:empty, .orbit p:empty').remove();jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function(){var $this=jQuery(this);var isWidescreen=$this.innerWidth()/$this.innerHeight()>1.5;$this.wrap("<div class='"+(isWidescreen?'widescreen':'')+" responsive-embed'/>");$this.attr('loading','lazy');// Lazy load the iframes
});jQuery('.lower-bar, .sticky-wrapper-navigation').removeClass('wait-js');//jQuery('<div class="svg-quote">...</div>').prependTo('blockquote');
}// Optimize OffCanvasSwitcher event handling and DOM manipulation
function initOffCanvasSwitcher(){var $offCanvas=jQuery('#off-canvas');function setOffcanvasPosition(newSize){var mobileOffcanvas=$offCanvas.data("mobile").split(" ");var tabletOffcanvas=$offCanvas.data("tablet").split(" ");if(newSize=='xmedium'||newSize=='medium'){switchPosition(tabletOffcanvas);}else if(newSize=='smedium'||newSize=='small'||newSize=='xsmall'){switchPosition(mobileOffcanvas);}}function switchPosition(offcanvasConfig){var _offcanvasConfig=_slicedToArray(offcanvasConfig,2),position=_offcanvasConfig[0],transition=_offcanvasConfig[1];$offCanvas.removeClass("position-"+currentPosition).addClass("position-"+position).attr("data-transition",transition).removeClass("is-transition-"+currentTransition).addClass("is-transition-"+transition);currentPosition=position;currentTransition=transition;}$window.on('load changed.zf.mediaquery',function(event,newSize){setOffcanvasPosition(newSize);});// Toggle classes for off-canvas open/close
$offCanvas.on('opened.zf.offCanvas',function(){jQuery("body").addClass('offCanvasOpen');jQuery(".hamburger").addClass("is-active");});$offCanvas.on('close.zf.offCanvas',function(){jQuery("body").removeClass('offCanvasOpen');jQuery(".hamburger").removeClass("is-active");});}// Simplify gallery click events
function initGalleries(){jQuery('.imgGalItem').click(function(event){var $this=jQuery(this);var link=$this.data('link');var rel=$this.attr('rel');var height=$this.attr('height');var width=$this.attr('width');var counts=$this.data('groups');var newContent='<a href="'+link+'" rel="galSlideCell'+rel+'" data-fancybox="group'+counts+'" data-caption="*Individual Results May Vary"><img src="'+link+'" height="'+height+'" width="'+width+'"></a>';var $mainGalImg=jQuery(".galSlideCell"+rel+" .main-gal-img");var containerHeight=$mainGalImg.height();jQuery(".photoGallery"+rel).removeClass("is-active");$this.addClass("is-active");$mainGalImg.stop().css({'opacity':'0','height':containerHeight+'px'}).html(newContent).animate({opacity:1},500);setTimeout(function(){$mainGalImg.css('height','auto');},500);event.preventDefault();return false;});}// Optimize fancybox attribute assignment
function initReplaceFancybox(){var fancyboxes=jQuery('.fancy-box a, .fancybox a, .is-style-button-has-play-video a, .is-style-play-video-link-w-icon a');fancyboxes.attr('data-fancybox','');}// Sticky navigation initialization
function initNavigation(){var $stickyNav=jQuery('.sticky-wrapper-navigation');$stickyNav.on('sticky.zf.stuckto:top',function(){$stickyNav.addClass('shrink');}).on('sticky.zf.unstuckfrom:top',function(){$stickyNav.removeClass('shrink');});}// Function to handle expand/collapse content
function clickToExpand(){jQuery('.is-style-click-to-expand').each(function(){var $this=jQuery(this);var ehmax=$this.data('eh-max');var $content=$this.wrapInner('<div class="expandrContent"></div>').find('.expandrContent');$this.append('<a class="expandBtn"><span class="showMe">Click To Expand</span><span class="hideMe">Click To Collapse</span> <i class="rotateMe none fa fa-angle-double-right" aria-hidden="true"></i></a>');$content.css('max-height',ehmax);$this.css('max-height',ehmax);$this.find('.expandBtn').click(function(){var $btn=jQuery(this);$btn.find('.rotateMe').toggleClass('none down');$btn.find('span').toggleClass('showMe hideMe');$content.toggleClass('expanded');$btn.toggleClass('expanded');});});jQuery('.is-style-team-click-to-expand').each(function(){var $this=jQuery(this);var ehmax=$this.data('eh-max');var $content=$this.wrapInner('<div class="expandrContent"></div>').find('.expandrContent');$this.prepend('<a class="expandBtn"><span class="showMe">Read More</span><span class="hideMe">Collapse Bio</span> <i class="rotateMe none fa fa-angle-double-right" aria-hidden="true"></i></a>');$content.css('max-height',ehmax);$this.css('max-height',ehmax);$this.find('.expandBtn').click(function(){var $btn=jQuery(this);$btn.find('.rotateMe').toggleClass('none down');$btn.find('span').toggleClass('showMe hideMe');$content.toggleClass('expanded');$btn.toggleClass('expanded');});});}var navigator;var DocumentTouch;//	Animations v1.1, Joe Mottershaw (hellojd)
//	https://github.com/hellojd/animations / https://github.com/Sananes/animations
//	==================================================
//	Visible, Sam Sehnert, samatdf, TeamDF
//	https://github.com/teamdf/jquery-visible/
//	==================================================
(function($){$.fn.visible=function(partial,hidden,direction){var $t=jQuery(this).eq(0),t=$t.get(0),$w=jQuery(window),viewTop=$w.scrollTop(),viewBottom=viewTop+$w.height(),viewLeft=$w.scrollLeft(),viewRight=viewLeft+$w.width(),_top=$t.offset().top,_bottom=_top+$t.height(),_left=$t.offset().left,_right=_left+$t.width(),compareTop=partial===true?_bottom:_top,compareBottom=partial===true?_top:_bottom,compareLeft=partial===true?_right:_left,compareRight=partial===true?_left:_right,clientSize=hidden===true?t.offsetWidth*t.offsetHeight:true;direction=direction?direction:'both';if(direction==='both')return!!clientSize&&compareBottom<=viewBottom&&compareTop>=viewTop&&compareRight<=viewRight&&compareLeft>=viewLeft;else if(direction==='vertical')return!!clientSize&&compareBottom<=viewBottom&&compareTop>=viewTop;else if(direction==='horizontal')return!!clientSize&&compareRight<=viewRight&&compareLeft>=viewLeft;};$.fn.fireAnimations=function(options){function animate(){if(jQuery(window).width()>=0){jQuery('.animate__animated').each(function(i,elem){elem=jQuery(elem);//var	type = jQuery(this).attr('data-anim-type'),
//delay = jQuery(this).attr('data-anim-delay');
if(elem.visible(true)){setTimeout(function(){elem.addClass('trigger');},100);}});}else{jQuery('.animate__animated').each(function(i,elem){elem=jQuery(elem);var type=jQuery(this).attr('data-anim-type'),delay=jQuery(this).attr('data-anim-delay');setTimeout(function(){elem.addClass(type);},delay);});}}jQuery(document).ready(function(){jQuery('html').removeClass('no-js').addClass('js');animate();});jQuery(window).scroll(function(){animate();if(jQuery(window).scrollTop()+jQuery(window).height()==jQuery(document).height()){animate();}});};jQuery('.animate').fireAnimations();})(jQuery);var triggerClasses='flash strobe shake bounce tada wave spin pullback wobble pulse pulsate heartbeat panic explode';var classesArray=[];classesArray=triggerClasses.split(' ');var classAmount=classesArray.length;var type;function randomClass(){var random=Math.ceil(Math.random()*classAmount);type=classesArray[random];return type;}function triggerOnce(target,type){if(type=='random'){type=randomClass();}jQuery(target).removeClass('trigger infinite '+triggerClasses).addClass('trigger').addClass(type).one('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend',function(){jQuery(this).removeClass('trigger infinite '+triggerClasses);});}function triggerInfinite(target,type){if(type=='random'){type=randomClass();}jQuery(target).removeClass('trigger infinite '+triggerClasses).addClass('trigger infinite').addClass(type).one('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend',function(){jQuery(this).removeClass('trigger infinite '+triggerClasses);});}jQuery(window).resize(function(){jQuery('.animate').fireAnimations();});function initBrowserExposure(){var uaMatch='',prefix='';if(navigator.userAgent.match(/Windows/)){jQuery('html').addClass('windows');}else if(navigator.userAgent.match(/Mac OS X/)){jQuery('html').addClass('macOs');}else if(navigator.userAgent.match(/X11/)){jQuery('html').addClass('x11');}var supports=function(){var d=document.documentElement,c="ontouchstart"in window||navigator.msMaxTouchPoints;if(c){d.className+=" touch";return{touch:true};}else{d.className+=" no-touch";return{touch:false};}}();// browser
if(navigator.userAgent.match(/Chrome/)){uaMatch=' Chrome/';prefix='chrome';}else if(navigator.userAgent.match(/Safari/)){uaMatch=' Version/';prefix='safari';}else if(navigator.userAgent.match(/Firefox/)){uaMatch=' Firefox/';prefix='firefox';}else if(navigator.userAgent.match(/MSIE/)){uaMatch=' MSIE ';prefix='x-msie';}// add result preifx as browser class
if(prefix){jQuery('html').addClass(prefix);}}// Get IE or Edge browser version
var version=detectIE();if(version===false){jQuery('html').addClass('not-ie-edge');}else if(version>=12){jQuery('html').addClass('edge edge-'+version);}else{jQuery('html').addClass('ie ie-'+version);}// add details to debug result
//document.getElementById('details').innerHTML = window.navigator.userAgent;
/**
	 * detect IE
	 * returns version of IE or false, if browser is not Internet Explorer
	 */function detectIE(){var ua=window.navigator.userAgent;// Test values; Uncomment to check result …
// IE 10
// ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
// IE 11
// ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
// Edge 12 (Spartan)
// ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
// Edge 13
// ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
var msie=ua.indexOf('MSIE ');if(msie>0){// IE 10 or older => return version number
return parseInt(ua.substring(msie+5,ua.indexOf('.',msie)),10);}var trident=ua.indexOf('Trident/');if(trident>0){// IE 11 => return version number
var rv=ua.indexOf('rv:');return parseInt(ua.substring(rv+3,ua.indexOf('.',rv)),10);}var edge=ua.indexOf('Edge/');if(edge>0){// Edge (IE 12+) => return version number
return parseInt(ua.substring(edge+5,ua.indexOf('.',edge)),10);}// other browser
return false;}})(jQuery);